import React from "react";
import svgPaths from "./svgPaths";
import img630774181Efb1B5Dc848F5E8Denislav402XJpg from "../assets/images/38308dcc53791283d38b2d2dbc37d42ecab90281.png";

function TestimonialsHeader() {
  return (
    <div className="h-auto flex flex-col gap-4 relative w-full lg:w-[1120px] items-center mb-8 lg:shrink-0 lg:mb-0 lg:h-[200px]" data-name="div.wrap-center">
      <h2 className="font-['Plus_Jakarta_Sans:Bold',sans-serif] font-bold text-3xl md:text-4xl lg:text-[40px] text-center text-[#2d3139]">
        Trusted by hundreds of professionals
      </h2>
      <p className="font-['Inter:Regular',sans-serif] font-normal text-base md:text-xl text-[#676d79] text-center max-w-[736px]">
        Some of the most memorable reviews we heard from our design colleagues.
      </p>
    </div>
  );
}

function TestimonialReviewSlide() {
  return (
    <div className="w-full flex flex-col gap-8 items-center" data-name="Group - 1 of 5">
      {/* Quote */}
      <div className="text-center font-['Plus_Jakarta_Sans:Bold',sans-serif] font-bold text-lg md:text-2xl lg:text-[36px] text-[#2d3139] leading-snug max-w-4xl px-4">
        <p>
          "Fixezy delivers exactly what every homeowner needs—verified professionals, on-time service, and complete peace of mind. It's the easiest way to manage home services."
        </p>
      </div>

      {/* Profile */}
      <div className="h-[130px] relative w-[212px] flex flex-col items-center gap-1" data-name="div.quote-owner">
        <div className="relative rounded-[100px] size-[60px]" data-name="630774181efb1b5dc848f5e8_denislav@2x.jpg">
          <div className="absolute inset-0 overflow-hidden pointer-events-none rounded-[100px]">
            <img alt="Rahul profile" className="absolute h-[149.69%] left-[-0.35%] max-w-none top-[-0.61%] w-full" src={img630774181Efb1B5Dc848F5E8Denislav402XJpg} />
          </div>
        </div>
        <p className="font-['Inter:Medium',sans-serif] font-medium text-lg text-[#2d3139] mt-2">
          Rahul
        </p>
        <p className="font-['Inter:Regular',sans-serif] font-normal text-sm text-[#676d79]">
          Homeowner, Bengaluru
        </p>
      </div>
    </div>
  );
}

function RegionCarousel() {
  return (
    <div className="bg-white border-t-6 border-[#0a7cff] drop-shadow-[0px_32px_32px_rgba(31,34,41,0.12)] rounded-bl-[12px] rounded-br-[12px] w-full max-w-[1075px] mx-auto py-12 relative flex items-center justify-center" data-name="Region - carousel">
      <TestimonialReviewSlide />
      <div className="absolute bottom-[16px] flex gap-[6px] items-center justify-center w-full">
        <div className="bg-[#0a7cff] rounded-[12px] size-[12px]" />
        <div className="bg-[rgba(10,124,255,0.32)] rounded-[8px] size-[8px]" />
        <div className="bg-[rgba(10,124,255,0.32)] rounded-[8px] size-[8px]" />
        <div className="bg-[rgba(10,124,255,0.32)] rounded-[8px] size-[8px]" />
        <div className="bg-[rgba(10,124,255,0.32)] rounded-[8px] size-[8px]" />
      </div>
    </div>
  );
}

export default function Testimonials() {
  return (
    <div className="w-full bg-white relative overflow-hidden flex flex-col gap-6 px-6 py-12 lg:h-[956px] lg:w-[1440px] lg:mx-auto lg:block lg:px-[128px] lg:py-[80px]" data-name="Section">
      <div className="flex flex-col items-center w-full max-w-[1184px] mx-auto relative gap-8" data-name="div.container">
        <TestimonialsHeader />
        {/* Stars decoration */}
        <div className="flex gap-[6px] items-center justify-center px-4 py-2 z-10 bg-white shadow-md rounded-full lg:absolute lg:top-[160px] lg:left-1/2 lg:-translate-x-1/2">
          <svg className="size-[20px] text-yellow-400 fill-current" viewBox="0 0 20 20">
            <path d={svgPaths.p36c1fcf0} />
          </svg>
          <svg className="size-[20px] text-yellow-400 fill-current" viewBox="0 0 20 20">
            <path d={svgPaths.p36c1fcf0} />
          </svg>
          <svg className="size-[20px] text-yellow-400 fill-current" viewBox="0 0 20 20">
            <path d={svgPaths.p36c1fcf0} />
          </svg>
          <svg className="size-[20px] text-yellow-400 fill-current" viewBox="0 0 20 20">
            <path d={svgPaths.p36c1fcf0} />
          </svg>
          <svg className="size-[20px] text-yellow-400 fill-current" viewBox="0 0 20 20">
            <path d={svgPaths.p36c1fcf0} />
          </svg>
        </div>
        <RegionCarousel />
      </div>
    </div>
  );
}
